import TopicOne from "../client-protection-contents/TopicOne";

const ClientProtectionContentOne = () => {
  return (
    <>
      <TopicOne />

      <div className="how__work__trading">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <div className="content-left">
                <h3>Transparent processes you can rely on</h3>
                <p>
                  We provide clear pricing, straightforward policies, and
                  complete visibility over your funds and orders. No hidden fees
                  or vague terms, just honest, transparent information at every
                  step of your trading journey.
                </p>
                <h3>Protection standards that go beyond compliance</h3>
                <p>
                  Your identity, transactions, and account are safeguarded
                  through strict KYC, AML, and multi-layer verification
                  protocols. Every trader, new or experienced, is protected by
                  the same robust, industry-leading security framework
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
              <div className="thumb-right">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/trading/client_protection/client_protection_1.png"
                  }
                  alt="computer images"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClientProtectionContentOne;
